import { Button, Form, InputNumber } from 'antd'
import { FC, useEffect } from 'react'
import { FormSection } from '@/presentation/common/components/FormSection.tsx'
import { useCrud } from '@/presentation/common/hooks/crud/useCrud.ts'
import { CreateEppProductFormProps } from '@/presentation/epp/forms/types.ts'
import { useCreateEppProduct } from '@/presentation/epp/hooks/useCreateEppProduct.ts'
import { useEppsMaintainerStore } from '@/presentation/epp/store/eppsMaintainers.ts'
import { InventorySelector } from '@/presentation/inventories/components/InventorySelector.tsx'
import { ProductStockSelector } from '@/presentation/inventoryProductsStocks/components/ProductStockSelector.tsx'

type CreateEppProductFormFields = {
    inventory: string
    product: string
    quantity: number
}

export const CreateEppProductForm: FC<CreateEppProductFormProps> = ({ onCancel, onFinish }) => {
  const messageApiKey = 'CreateEppProductForm-alert'
  const { submit, isSuccess, isLoading, isError, message } = useCreateEppProduct()
  useCrud({ messageApiKey, message, isSuccess, isLoading, isError })

  const [ form ] = Form.useForm<CreateEppProductFormFields>()
  const inventory = Form.useWatch('inventory', form)

  const { selectedEppId } = useEppsMaintainerStore()

  const onSubmit = async (values: CreateEppProductFormFields) => {
    if (isLoading || !selectedEppId) {
      return
    }

    const response = await submit({
      query: {
        eppId: selectedEppId,
      },
      body: {
        product   : values.product,
        inventory : values.inventory,
        quantity  : values.quantity,
      },
    })
    if (response) {
      onFinish?.()
    }
  }

  useEffect(() => {
    form.resetFields([ 'product' ])
  }, [ inventory ])

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 4 }}
      labelAlign="left"
      labelWrap
      colon={false}
      onFinish={onSubmit}
    >
      <FormSection title="Datos del producto">
        <Form.Item
          label="Inventario"
          name="inventory"
          rules={[{ required: true }]}
        >
          <InventorySelector/>
        </Form.Item>

        <Form.Item
          label="Producto"
          name="product"
          rules={[{ required: true }]}
        >
          <ProductStockSelector filters={{ inventoryId: inventory }}/>
        </Form.Item>

        <Form.Item
          label="Cantidad"
          name="quantity"
          rules={[{ required: true }]}
        >
          <InputNumber min={0}/>
        </Form.Item>
      </FormSection>

      <div className="flex justify-center gap-2.5 pb-2">
        <Button size="small" onClick={onCancel} disabled={isLoading}>Cancelar</Button>
        <Button size="small" type="primary" htmlType="submit" disabled={isLoading}>Registrar</Button>
      </div>
    </Form>
  )
}
